// The search bar's type toggle (Phase B). Its own tiny module so the homepage
// can import it without pulling the lazily-loaded browse/listing code into the
// first download.
export const SCOPE_OPTIONS = [["all", "All"], ["retreats", "Retreats"], ["teacher_training", "Yoga Teacher Training"], ["classes", "Classes"]];
